export const restrictions = {
    MAX_GROUPS_PER_CONTACT: 50,
    MAX_NAME_LENGTH: 40,
    MAX_GROUPS_PER_INVITE: 50,
};

export const permissionChartLink =
    'https://support.voxie.com/hc/en-us/articles/31451900136461-Groups-Franchise-Hub-Lifecycle-Management-toolset#h_01JBCG0N6PV4TERJPVJW8FT1E6';
